import { SectionAtmosphere } from '../layout/HoldingBackdrop';

export default function Stats() {
  const stats = [
    {
      value: '99.99%',
      label: 'Uptime target',
    },
    {
      value: '90 days',
      label: 'Pilot to production',
    },
    {
      value: 'AES-256',
      label: 'Encryption baseline',
    },
    {
      value: 'Verified',
      label: 'Tamper-evident records',
    },
  ];

  return (
    <section className="relative isolate z-20 overflow-hidden" aria-label="Key metrics">
      <SectionAtmosphere variant="stats" />
      <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-2 gap-x-4 gap-y-10 px-5 py-10 md:grid-cols-4 md:gap-x-8 md:gap-y-6 md:px-8 md:py-14">
        {stats.map((stat, index) => (
          <div
            key={stat.label}
            className="animate-on-scroll text-center md:border-x md:border-[#e8ede4]/[0.06] md:py-1 md:first:border-l-0 md:last:border-r-0"
            style={{ transitionDelay: `${index * 70}ms` }}
          >
            <p className="text-3xl font-semibold tracking-[-0.04em] text-teal-100/95 tabular-nums md:text-[2.35rem]">
              {stat.value}
            </p>
            <p
              className="mx-auto mt-2 max-w-[14rem] text-[0.8125rem] leading-snug text-[#d6ddcf]/85 line-clamp-1 md:max-w-[18rem] md:text-sm md:leading-tight"
              title={stat.label}
            >
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
